import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "game-header mt-0" }
const _hoisted_2 = { class: "flex items-center text-white text-lg" }
const _hoisted_3 = {
  key: 0,
  class: "xr-icon-game text-blue-primary mr-2"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "inline-block ml-2" }
const _hoisted_7 = {
  key: 0,
  class: "xr-test-net mr-1 relative top-0.5"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "path1" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "path2" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "path3" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "path4" }, null, -1)
const _hoisted_12 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "xr-main-net relative top-0.5"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "path1" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "path2" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "path3" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "path4" }, null, -1)
const _hoisted_18 = [
  _hoisted_14,
  _hoisted_15,
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { class: "text-gray-text text-md mt-2 truncate" }
const _hoisted_20 = { class: "grid grid-cols-2 my-5" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("small", { class: "text-yellow-bar mb-0 text-xs" }, "Current Version", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = {
  key: 0,
  class: "text-white font-bold"
}
const _hoisted_24 = {
  key: 1,
  class: "text-white font-bold"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("small", { class: "text-yellow-bar mb-0 text-xs" }, "Namespace Expires on", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = { class: "text-white" }
const _hoisted_28 = ["href"]
const _hoisted_29 = { class: "border-t border-gray-900 py-2 pt-3" }
const _hoisted_30 = {
  key: 0,
  class: "badge-yellow"
}
const _hoisted_31 = {
  key: 1,
  class: "badge-red"
}
const _hoisted_32 = {
  key: 2,
  class: "badge-blue"
}
const _hoisted_33 = {
  key: 3,
  class: "badge-blue"
}
const _hoisted_34 = {
  key: 4,
  class: "badge-blue"
}
const _hoisted_35 = {
  key: 5,
  class: "badge-gray"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    class: "no-underline bg-black-header hover:bg-black-ori transform hover:-translate-y-1 rounded-sm p-3 block shadow-xl transition-all duration-200",
    to: {name: 'viewGamesUpdate', params: {gameId: _ctx.item.gameId}}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.item.logo == 'placeholder' || _ctx.item.logo =='')
            ? (_openBlock(), _createElementBlock("i", _hoisted_3))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: _ctx.assetUrl + 'blob/games/' + _ctx.item.gameId + '/' + _ctx.item.logo,
                class: "mr-2 w-6 h-6 rounded-full inline-block"
              }, null, 8, _hoisted_4)),
          _createElementVNode("div", {
            class: "truncate flex-grow whitespace-nowrap",
            title: _ctx.item.title ? _ctx.item.title : _ctx.item.name
          }, _toDisplayString(_ctx.item.title ? _ctx.item.title : _ctx.item.name), 9, _hoisted_5),
          _createElementVNode("div", _hoisted_6, [
            (_ctx.item.status === 3)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _hoisted_12))
              : _createCommentVNode("", true),
            (_ctx.isMainnet)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, _hoisted_18))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("small", _hoisted_19, "Namespace ID: " + _toDisplayString(_ctx.item.gameId), 1)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", null, [
          _hoisted_21,
          _hoisted_22,
          (_ctx.item.version)
            ? (_openBlock(), _createElementBlock("small", _hoisted_23, " Version " + _toDisplayString(_ctx.item.version), 1))
            : (_openBlock(), _createElementBlock("small", _hoisted_24, " No version yet! "))
        ]),
        _createElementVNode("div", null, [
          _hoisted_25,
          _hoisted_26,
          _createElementVNode("small", _hoisted_27, _toDisplayString(_ctx.item.newExpiryFormat), 1),
          (_ctx.item.isExpiring)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                href: _ctx.network=='testnet'?_ctx.testnetWebWallet:_ctx.mainnetWebWallet,
                target: "_new",
                class: "p-1 text-xs bg-yellow-500 hover:bg-yellow-600 transition-all duration-200 text-white rounded-md inline-block"
              }, "Expiring soon", 8, _hoisted_28))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        (_ctx.item.status === 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_30, "Pending Approval"))
          : (_ctx.item.status === 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_31, "Game is Rejected"))
            : (_ctx.item.status === 2)
              ? (_openBlock(), _createElementBlock("span", _hoisted_32, "Game is Approved"))
              : (_ctx.item.status === 3)
                ? (_openBlock(), _createElementBlock("span", _hoisted_33, "Game is Active in " + _toDisplayString(_ctx.testnetLabel), 1))
                : (_ctx.item.status === 4)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_34, "Game is Active in " + _toDisplayString(_ctx.mainnetLabel), 1))
                  : (_ctx.item.status === -1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_35, "Game not submitted"))
                    : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["to"]))
}